import LockModal from "components/Common/LockModal"
import React from "react"
import { Navigate } from "react-router-dom"

const Authmiddleware = props => {
  if (!localStorage.getItem("authUser")) {
    return (
      <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    )
  }

  if (localStorage.getItem("isLocked") === "true") {
    return (
      <LockModal
        isOpen={true}
        toggle={() => localStorage.setItem("isLocked", "false")}
      />
    )
  }
  return <React.Fragment>{props.children}</React.Fragment>
}

export default Authmiddleware
